import React from 'react';
import { useAtomValue } from 'jotai';
import { Suggestions, Value } from '../Suggestions';
import { onFilterChange } from '@src/fragments/Filters/utils/FilterStateUtility';
import { XclusionUtility } from '@src/fragments/Filters/managers/XclusionUtility';
import {
  creatorCountriesExcludeState,
  creatorCountriesInput,
} from '@src/pages/Discover/components/Selectors/Selectors';
import { useFiltersParams } from '@src/hooks/useFiltersParams';

interface Props {
  availableCountries: string[];
}

export function CreatorCountriesSuggestion({ availableCountries }: Props) {
  const { filters, setFilters } = useFiltersParams();
  const exclude = useAtomValue(creatorCountriesExcludeState);
  const filterCreatorCountriesInput = useAtomValue(creatorCountriesInput);

  // Map available countries to suggestion objects, sorted alphabetically
  const allCountries: Value[] = availableCountries
    .slice()
    .sort((a, b) => a.localeCompare(b))
    .map((country) => ({
      key: country,
      children: <span>{country}</span>,
    }));

  // Filter selected countries and handle inclusion/exclusion
  const rawKeys = XclusionUtility.getRawKeys(filters.creatorCountries || []);
  const selectedValues: Value[] = allCountries.filter((country) =>
    rawKeys.includes(country.key)
  );

  // Filter countries based on user input
  const filteredValues = filterCreatorCountriesInput ? allCountries.filter((country) =>
    country.key.toLowerCase().includes(filterCreatorCountriesInput.toLowerCase())
  ) : allCountries;

  return (
    <Suggestions
      values={filteredValues}
      selectedValues={selectedValues}
      onChange={onFilterChange(setFilters, 'creatorCountries')}
      exclude={exclude}
    />
  );
}
